import { Formik, Form, Field, ErrorMessage } from "formik";
import HeaderDescriptive from "src/components/HeaderDescriptive";
import PageHeader from "src/components/PageHeader";
import FormikField from "src/components/FormikField/FormikField";
import { useNavigate } from "react-router-dom";
import { FiUserPlus } from "react-icons/fi";
import { useEffect, useState } from "react";
import { get, post } from "src/services/HttpClient";
import { notify } from "src/services/Notification/Notification";
import useGetCurrentURL from "src/utils/useGetCurrentURL";
import TwinButton from "src/components/TwinButton";
import { getData } from "src/actions/getData";

export default function AddUser() {
    const [roleOptions, setRoleOptions] = useState()

    const [isLoading, setIsLoading] = useState(false)
    const navigate = useNavigate();
    const pathname = useGetCurrentURL();


    useEffect(() => {
        getData((result) => {
            setRoleOptions(result.map(role => {
                return {
                    value: role?.id,
                    label: role?.roleTranslate
                }
            }))
        }, "/roles")
    }, [])
    return (
        <>
            <PageHeader title="افزودن کاربر جدید" />
            <Formik
                initialValues={{
                    fullName: "",
                    email: "",
                    password: "",
                    roleId: "",
                }}
                onSubmit={async (values, { setSubmitting }) => {
                    setIsLoading(true)
                    const result = await post("/register", {
                        fullName: values.fullName,
                        email: values.email,
                        password: values.password,
                        roleId: values.roleId,
                    });
                    if (result) {
                        notify("کاربر با موفقیت به سیستم اضافه شد")
                        navigate(pathname.slice(0, pathname.search("/add")));
                    } else {
                        notify("خطایی رخ داده است", "error")
                    }
                    setIsLoading(false)
                }}
            >
                {({ values, errors, touched, setFieldValue }) => (
                    <Form>
                        <div className="flex flex-col bg-white dark:bg-black rounded-2xl p-10 px-20">
                            <HeaderDescriptive
                                title="اطلاعات کاربر"
                                description="اطلاعات زیر را برای اضافه شدن کاربر تکمیل نمایید"
                            >
                                <FiUserPlus size={40} />
                            </HeaderDescriptive>
                            <div className="flex gap-10 mt-10 ">
                                <div className="flex flex-col xl:grid gap-5 gap-y-9 grid-cols-2  w-full justify-center">
                                    <FormikField
                                        inputName="fullName"
                                        label="نام"
                                        placeholder="نام کامل کاربر را وارد کنید..."
                                        // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="email"
                                        label="ایمیل"
                                        placeholder="ایمیل کاربر را وارد کنید..."
                                        // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                        errors={errors}
                                    />
                                    <FormikField
                                        type="password"
                                        inputName="password"
                                        label="گذرواژه"
                                        placeholder="گذرواژه کاربر را وارد کنید..."
                                        // info="بصورت رشته ای است و نام سازمان را مشخص می کند"
                                        errors={errors}
                                    />
                                    <FormikField
                                        inputName="roleId"
                                        type="select"
                                        label="سطح دسترسی"
                                        placeholder="سطح دسترسی کاربر را وارد کنید..."
                                        errors={errors}
                                        options={roleOptions}
                                        values={values}
                                        setFieldValue={setFieldValue}
                                    />

                                </div>
                            </div>
                            <TwinButton
                                rejectHandle={() => {
                                    navigate(pathname.slice(0, pathname.search("/add")));
                                }}
                                isLoading={isLoading}
                            />
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
}
